import API from './index'
import AES from '../assets/commonjs/aes'


class Rong {

  getPersonList = (params) => {
    return API.rongHttp(params).then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    })
  }

  show_history = (params) => {
    // console.log(params)
    return API.single_conv_Ry(params).then(response => {
      console.log(response,'单人记录')
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }

  group_history = (params) => {
    return API.group_conv_Ry(params).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }

  download_s_Ry = (params) => {
    return API.download_Ry(params).then(response => {

      return response.data
    }).catch(error => {
      console.log(error)
    })
  }
  download_g_Ry = (params) => {
    return API.download_group_Ry(params).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }

}

export default new Rong()



// WEBPACK FOOTER //
// ./src/api/rong.js